import { SocialInfo } from '@app/shared';

import { capitalizeInitials } from './../utils';

export interface Manager {
  id: number;
  firstName: string;
  lastName: string;

  department: string;
  company?: {
    id: number;
  };
  jobTitle: string;
  email: string;
  mobile: string;
  photoId?: number;
  socialInfos?: SocialInfo[];
}

export class ManagerAutoOptionAdapter {
  static toOption(manager: Manager): any {
    // TODO: create better type
    return !!manager && !!manager.id
      ? {
          id: manager.id,
          label: `${manager.firstName} ${manager.lastName}`,
          capitals: capitalizeInitials(`${manager.firstName} ${manager.lastName}`),
          imageId: manager.photoId,
          option: manager,
        }
      : null;
  }
}
